module.exports = __webpack_public_path__ + "static/img/default_avatar.f7d08910.png";